import * as Table from "../../../src/Components/Table/Table.scss";
import * as light from "flatpickr/dist/themes/light.css";
import * as react from "react";
import { tryHead, ofArray, item as item_1, mapIndexed, cons, append, getSlice, empty, head, tail as tail_1, isEmpty, length, singleton, map } from "../../fable_modules/fable-library.3.7.20/List.js";
import { Union, Record } from "../../fable_modules/fable-library.3.7.20/Types.js";
import { unit_type, lambda_type, obj_type, union_type, tuple_type, record_type, option_type, string_type, int32_type, list_type, class_type } from "../../fable_modules/fable-library.3.7.20/Reflection.js";
import { FunctionComponent_Of_Z5A158BBF } from "../../fable_modules/Fable.React.7.4.3/Fable.React.FunctionComponent.fs.js";
import { printf, toText } from "../../fable_modules/fable-library.3.7.20/String.js";
import { equals, partialApply, uncurry, max, round, int32ToString, comparePrimitives, min } from "../../fable_modules/fable-library.3.7.20/Util.js";
import { classNames, DateTimeExtensions_toDateHHmmss, logwi, Locale$reflection, createThrottle, querySelectorAll } from "../../Utils.js";
import { attachDisposableEvent } from "../Hooks/Common.js";
import { DOMAttr, HTMLAttr, CSSProp, Prop } from "../../fable_modules/Fable.React.7.4.3/Fable.React.Props.fs.js";
import { keyValueList } from "../../fable_modules/fable-library.3.7.20/MapUtil.js";
import { empty as empty_1, singleton as singleton_1, append as append_1, delay, toList } from "../../fable_modules/fable-library.3.7.20/Seq.js";
import { map as map_1, defaultArg, value as value_3 } from "../../fable_modules/fable-library.3.7.20/Option.js";
import { TextProps$1, TextProps$1_GetDefault, render as render_1 } from "../StatefulFormFields/Text.js";
import { Browser_Types_Event__Event_get_Value } from "../../fable_modules/Fable.React.7.4.3/Fable.React.Extensions.fs.js";
import { DateOptions, DateOptions_get_getDefault, inputDate, SelectOption, ValueProp as ValueProp_1, SelectOption_get_getDefault, selectOption } from "../FormFields/FormFields.js";
import { OnChange as OnChange_2, Value as Value_2 } from "../../fable_modules/Fable.React.Flatpickr.3.0.0/Flatpickr.fs.js";
import { Size, getMaterialIconBySize, getWrappedMaterialIcon } from "../../ViewUtils.js";
import { effect } from "../Hooks/ClickOutside.js";



export function Elements_renderHeader(header) {
    return react.createElement("th", {
        className: "head",
    }, header);
}

export function Elements_renderCell(content) {
    return react.createElement("td", {
        className: "cell",
    }, content);
}

export function Elements_renderRow(mapper, cells) {
    const children = map((arg) => Elements_renderCell(mapper(arg)), cells);
    return react.createElement("tr", {}, ...children);
}

export function Elements_renderTHead(headers) {
    let children;
    const children_2 = [(children = map(Elements_renderHeader, headers), react.createElement("tr", {}, ...children))];
    return react.createElement("thead", {}, ...children_2);
}

export function Elements_renderTBody(mapper, rows) {
    const children = map((cells) => Elements_renderRow(mapper, cells), rows);
    return react.createElement("tbody", {
        className: "body",
    }, ...children);
}

export function Elements_renderSideTable(mapper, header, rows) {
    const children = [Elements_renderTHead(singleton(header)), Elements_renderTBody(mapper, rows)];
    return react.createElement("table", {
        className: "table-side",
    }, ...children);
}

export function renderHeader(header) {
    return Elements_renderHeader(header);
}

export function renderCell(content) {
    return Elements_renderCell(content);
}

export function renderRow(cells) {
    const children = map(renderCell, cells);
    return react.createElement("tr", {}, ...children);
}

export function renderTHead(headers) {
    let children;
    const children_2 = [(children = map(renderHeader, headers), react.createElement("tr", {}, ...children))];
    return react.createElement("thead", {}, ...children_2);
}

export function renderTBody(rows) {
    return Elements_renderTBody((s) => s, rows);
}

export function renderTable(headers, rows) {
    const children = [renderTHead(headers), renderTBody(rows)];
    return react.createElement("table", {
        className: "table-base",
    }, ...children);
}

export function renderCustomTable(headersTh, rowsTr) {
    let children_2;
    const children_6 = [(children_2 = [react.createElement("tr", {}, ...headersTh)], react.createElement("thead", {}, ...children_2)), react.createElement("tbody", {
        className: "body",
    }, ...rowsTr)];
    return react.createElement("table", {
        className: "table-base",
    }, ...children_6);
}

export function renderSideTable(header, rows) {
    return Elements_renderSideTable((s) => s, header, rows);
}

class ScrollableTableProps extends Record {
    constructor(TableHeadersThs, TableRowsTrs, NrOfVisibleRows, Id, RefOpt) {
        super();
        this.TableHeadersThs = TableHeadersThs;
        this.TableRowsTrs = TableRowsTrs;
        this.NrOfVisibleRows = (NrOfVisibleRows | 0);
        this.Id = Id;
        this.RefOpt = RefOpt;
    }
}

function ScrollableTableProps$reflection() {
    return record_type("Components.Table.ScrollableTableProps", [], ScrollableTableProps, () => [["TableHeadersThs", list_type(class_type("Fable.React.ReactElement"))], ["TableRowsTrs", list_type(class_type("Fable.React.ReactElement"))], ["NrOfVisibleRows", int32_type], ["Id", string_type], ["RefOpt", option_type(class_type("Fable.React.IRefValue`1", [option_type(class_type("Browser.Types.Element", void 0, Element))]))]]);
}

const renderScrollableTable$0027 = FunctionComponent_Of_Z5A158BBF((props) => {
    let props_1, css, props_3, css_1, rowEndIndex, props_11, children_10, children_6;
    let containerKey;
    const arg = length(props.TableRowsTrs) | 0;
    containerKey = toText(printf("container-key-%i"))(arg);
    const rowHeightState = react.useState(void 0);
    const rowIndexWindowState = react.useState([0, min(comparePrimitives, 50, length(props.TableRowsTrs))]);
    const containerRef = react.useRef(void 0);
    react.useEffect(() => {
        let arg_1;
        const tableRows = querySelectorAll(("#" + props.Id) + " tr");
        const calculatedRowHeightOpt = (!isEmpty(tableRows)) ? ((!isEmpty(tail_1(tableRows))) ? ((!isEmpty(tail_1(tail_1(tableRows)))) ? (~(~((arg_1 = head(tail_1(tail_1(tableRows))).getBoundingClientRect().height, Math.ceil(arg_1))))) : (void 0)) : (void 0)) : (void 0);
        const matchValue = [calculatedRowHeightOpt, rowHeightState[0]];
        let pattern_matching_result;
        if (matchValue[0] != null) {
            if (matchValue[1] == null) {
                pattern_matching_result = 1;
            }
            else if (matchValue[0] !== matchValue[1]) {
                pattern_matching_result = 0;
            }
            else {
                pattern_matching_result = 2;
            }
        }
        else {
            pattern_matching_result = 2;
        }
        switch (pattern_matching_result) {
            case 0: {
                rowHeightState[1](calculatedRowHeightOpt);
                break;
            }
            case 1: {
                rowHeightState[1](calculatedRowHeightOpt);
                break;
            }
        }
        const matchValue_1 = [length(tableRows) > 1, calculatedRowHeightOpt];
        let pattern_matching_result_1;
        if (matchValue_1[0]) {
            if (matchValue_1[1] != null) {
                pattern_matching_result_1 = 0;
            }
            else {
                pattern_matching_result_1 = 1;
            }
        }
        else {
            pattern_matching_result_1 = 1;
        }
        switch (pattern_matching_result_1) {
            case 0: {
                const scrollHeight = int32ToString(3 + (matchValue_1[1] * props.NrOfVisibleRows));
                const matchValue_2 = containerRef.current;
                if (matchValue_2 == null) {
                }
                else {
                    const container = matchValue_2;
                    container.style.maxHeight = (scrollHeight + "px");
                }
                break;
            }
            case 1: {
                break;
            }
        }
    }, [props.TableRowsTrs, props.NrOfVisibleRows]);
    const throttle100ms = createThrottle(50);
    const setRowIndexWindow = () => {
        let matchValue_4, container_1;
        const matchValue_3 = rowHeightState[0];
        if (matchValue_3 != null) {
            const rowHeight_2 = matchValue_3 | 0;
            const nrOfRowsScrolledPast = (~(~round(((matchValue_4 = containerRef.current, (matchValue_4 == null) ? 0 : ((container_1 = matchValue_4, container_1.scrollTop)))) / rowHeight_2))) | 0;
            const patternInput = [max(comparePrimitives, 0, nrOfRowsScrolledPast - 50), min(comparePrimitives, length(props.TableRowsTrs) - 1, nrOfRowsScrolledPast + 50)];
            rowIndexWindowState[1]([patternInput[0], patternInput[1]]);
        }
    };
    react.useEffect(setRowIndexWindow, [props.TableRowsTrs]);
    react.useEffect(() => {
        const disp = (() => {
        const matchValue_5 = containerRef.current;
        return (matchValue_5 != null) ? attachDisposableEvent((_arg) => {
            throttle100ms(setRowIndexWindow);
        }, matchValue_5, "scroll") : {
            Dispose() {
            },
        };
    })();
        return () => disp.Dispose();
    }, [props.TableRowsTrs, [rowIndexWindowState[0], rowHeightState[0]]]);
    let rows;
    let windowedRows;
    const startIndex = ((length(props.TableRowsTrs) <= 0) ? 0 : min(comparePrimitives, (rowIndexWindowState[0])[0], max(comparePrimitives, 0, length(props.TableRowsTrs) - 1))) | 0;
    const endIndex = ((length(props.TableRowsTrs) <= 0) ? 0 : min(comparePrimitives, (rowIndexWindowState[0])[1], max(comparePrimitives, 0, length(props.TableRowsTrs) - 1))) | 0;
    windowedRows = ((length(props.TableRowsTrs) <= 0) ? empty() : getSlice(startIndex, endIndex, props.TableRowsTrs));
    let rowHeight_4;
    const matchValue_9 = rowHeightState[0];
    rowHeight_4 = ((matchValue_9 == null) ? 0 : matchValue_9);
    rows = append(cons((props_1 = [new Prop(0, "upper-filler-row"), (css = singleton(new CSSProp(189, (rowIndexWindowState[0])[0] * rowHeight_4)), ["style", keyValueList(css, 1)])], react.createElement("tr", keyValueList(props_1, 1))), windowedRows), singleton((props_3 = [new Prop(0, "bottom-filler-row"), (css_1 = singleton(new CSSProp(189, ((rowEndIndex = ((rowIndexWindowState[0])[1] | 0), (rowEndIndex >= (length(props.TableRowsTrs) - 1)) ? 0 : (length(props.TableRowsTrs) - rowEndIndex))) * rowHeight_4)), ["style", keyValueList(css_1, 1)])], react.createElement("tr", keyValueList(props_3, 1)))));
    const children_12 = [(props_11 = toList(delay(() => append_1(singleton_1(new HTMLAttr(65, "table-base scrollable-table")), delay(() => ((props.RefOpt != null) ? singleton_1(new Prop(3, value_3(props.RefOpt))) : empty_1()))))), (children_10 = [(children_6 = [react.createElement("tr", {}, ...props.TableHeadersThs)], react.createElement("thead", {}, ...children_6)), react.createElement("tbody", {
        className: "body",
    }, ...rows)], react.createElement("table", keyValueList(props_11, 1), ...children_10)))];
    return react.createElement("div", {
        id: props.Id,
        className: "scrollable-table-container",
        ref: containerRef,
        key: containerKey,
    }, ...children_12);
}, "ScrollableTable", uncurry(2, void 0), void 0, "renderScrollableTable\u0027", "E:\\w\\1835\\s\\FenixWebApp\\fable\\src\\Components\\Table\\Table.fs", 209);

export function renderScrollableTable(tableHeadersThs, tableRowsTrs, scrollStart, id, refOpt) {
    return renderScrollableTable$0027(new ScrollableTableProps(tableHeadersThs, tableRowsTrs, scrollStart, id, refOpt));
}

export class EditType extends Union {
    constructor(tag, ...fields) {
        super();
        this.tag = (tag | 0);
        this.fields = fields;
    }
    cases() {
        return ["Text", "Number", "Option", "Date", "NotEditable"];
    }
}

export function EditType$reflection() {
    return union_type("Components.Table.EditType", [], EditType, () => [[], [], [["Item", list_type(tuple_type(string_type, string_type))]], [["Item", list_type(class_type("Flatpickr.IFlatpickrOption"))]], []]);
}

export class TableCell extends Record {
    constructor(Value, EditType, ToString, FromString) {
        super();
        this.Value = Value;
        this.EditType = EditType;
        this.toString = ToString;
        this.FromString = FromString;
    }
}

export function TableCell$reflection() {
    return record_type("Components.Table.TableCell", [], TableCell, () => [["Value", obj_type], ["EditType", EditType$reflection()], ["ToString", lambda_type(obj_type, string_type)], ["FromString", lambda_type(string_type, obj_type)]]);
}

export class EditableTableProps extends Record {
    constructor(Rows, SaveRow, Headers, Locale) {
        super();
        this.Rows = Rows;
        this.SaveRow = SaveRow;
        this.Headers = Headers;
        this.Locale = Locale;
    }
}

export function EditableTableProps$reflection() {
    return record_type("Components.Table.EditableTableProps", [], EditableTableProps, () => [["Rows", list_type(list_type(TableCell$reflection()))], ["SaveRow", lambda_type(list_type(TableCell$reflection()), unit_type)], ["Headers", list_type(string_type)], ["Locale", Locale$reflection()]]);
}

export const renderEditableTable = FunctionComponent_Of_Z5A158BBF((props) => {
    const currentEditingRowState = react.useState(void 0);
    const updateEditingRowState = (cellId, value) => {
        const matchValue_1 = currentEditingRowState[0];
        if (matchValue_1 != null) {
            const rowId_1 = matchValue_1[0] | 0;
            const updatedCells = mapIndexed((i, cell) => {
                if (i === cellId) {
                    return new TableCell(cell.FromString(value), cell.EditType, cell.toString, cell.FromString);
                }
                else {
                    return cell;
                }
            }, matchValue_1[1]);
            currentEditingRowState[1]([rowId_1, updatedCells]);
        }
    };
    const headers = append(props.Headers, singleton(""));
    const rows = mapIndexed((rowId_2, cells_2) => {
        let children_10, children_8, children_4, children_6, children_2, children;
        let isEditingCurrentRow;
        const matchValue_4 = currentEditingRowState[0];
        isEditingCurrentRow = ((matchValue_4 != null) && (matchValue_4[0] === rowId_2));
        const children_12 = append(mapIndexed((cellId_1, cell_1) => {
            let cell_2, matchValue_2, rowId_3, matchValue_3, inputRecord_1, inputRecord_2, flatpickrOptions, inputRecord_3, inputRecord;
            return Elements_renderCell(isEditingCurrentRow ? ((cell_2 = ((matchValue_2 = (currentEditingRowState[0]), (matchValue_2 != null) ? ((rowId_3 = (matchValue_2[0] | 0), item_1(cellId_1, matchValue_2[1]))) : ((logwi("renderEditableTable has inconsistent state."), cell_1)))), (matchValue_3 = cell_2.EditType, (matchValue_3.tag === 1) ? render_1()((inputRecord_1 = TextProps$1_GetDefault(), new TextProps$1(cell_2.toString(cell_2.Value), "number", inputRecord_1.Classes, (e_1) => {
                updateEditingRowState(cellId_1, Browser_Types_Event__Event_get_Value(e_1));
            }, inputRecord_1.Disabled, inputRecord_1.LabelText, inputRecord_1.Id, inputRecord_1.ValidationFn, inputRecord_1.DynamicWidth, inputRecord_1.HTMLProps, inputRecord_1.OnBlur, inputRecord_1.OnFocus, inputRecord_1.AutoComplete, inputRecord_1.Name))) : ((matchValue_3.tag === 2) ? selectOption((inputRecord_2 = SelectOption_get_getDefault(), new SelectOption(new ValueProp_1(0, cell_2.toString(cell_2.Value), (e_2) => {
                updateEditingRowState(cellId_1, Browser_Types_Event__Event_get_Value(e_2));
            }), inputRecord_2.Id, matchValue_3.fields[0], inputRecord_2.Classes, inputRecord_2.LabelText, inputRecord_2.Disabled, inputRecord_2.HTMLProps))) : ((matchValue_3.tag === 3) ? ((flatpickrOptions = ofArray([Value_2(cell_2.Value), OnChange_2((date) => {
                updateEditingRowState(cellId_1, DateTimeExtensions_toDateHHmmss(props.Locale.ILocale, date));
            })]), inputDate((inputRecord_3 = DateOptions_get_getDefault(), new DateOptions(append(matchValue_3.fields[0], flatpickrOptions), inputRecord_3.LabelText, false, inputRecord_3.Disabled, inputRecord_3.OnClearClick))))) : ((matchValue_3.tag === 4) ? cell_2.toString(cell_2.Value) : render_1()((inputRecord = TextProps$1_GetDefault(), new TextProps$1(cell_2.toString(cell_2.Value), inputRecord.Type, inputRecord.Classes, (e) => {
                updateEditingRowState(cellId_1, Browser_Types_Event__Event_get_Value(e));
            }, inputRecord.Disabled, inputRecord.LabelText, inputRecord.Id, inputRecord.ValidationFn, inputRecord.DynamicWidth, inputRecord.HTMLProps, inputRecord.OnBlur, inputRecord.OnFocus, inputRecord.AutoComplete, inputRecord.Name))))))))) : cell_1.toString(cell_1.Value));
        }, cells_2), singleton(isEditingCurrentRow ? ((children_10 = [(children_8 = [(children_4 = [getWrappedMaterialIcon("save")], react.createElement("span", {
            className: "cell__icon",
            onClick: (_arg_1) => {
                const matchValue = currentEditingRowState[0];
                if (matchValue != null) {
                    const rowId = matchValue[0] | 0;
                    props.SaveRow(matchValue[1]);
                }
                else {
                    logwi("[EditableTable - saveRow] No row currently editing.");
                }
            },
        }, ...children_4)), (children_6 = [getWrappedMaterialIcon("close")], react.createElement("span", {
            className: "cell__icon",
            onClick: (_arg_2) => {
                currentEditingRowState[1](void 0);
            },
        }, ...children_6))], react.createElement("div", {
            className: "cell__icon-wrap",
        }, ...children_8))], react.createElement("td", {
            className: "cell",
        }, ...children_10))) : ((children_2 = [(children = [getWrappedMaterialIcon("edit")], react.createElement("span", {
            className: "cell__icon",
        }, ...children))], react.createElement("td", {
            className: "cell",
            onClick: (_arg) => {
                currentEditingRowState[1]([rowId_2, cells_2]);
            },
        }, ...children_2)))));
        return react.createElement("tr", {}, ...children_12);
    }, props.Rows);
    const children_16 = [renderTHead(headers), react.createElement("tbody", {
        className: "body",
    }, ...rows)];
    return react.createElement("table", {
        className: "editable-table",
    }, ...children_16);
}, "EditableTable", uncurry(2, void 0), void 0, "renderEditableTable", "E:\\w\\1835\\s\\FenixWebApp\\fable\\src\\Components\\Table\\Table.fs", 352);

export function renderTableWithAuxComponent(header, auxComponent, rows, isEditing, onEditClick, onSaveClick, onCancelClick) {
    let children_2, children_4, children_8, children_22, children_18, children_16, props_14, children_14, props_12;
    const rowsHtml = map((row) => {
        const tableCells = map(Elements_renderCell, row[0]);
        return react.createElement("tr", {
            id: row[1],
        }, ...tableCells);
    }, rows);
    let headerIcons;
    if (isEditing) {
        const children_6 = [(children_2 = [getMaterialIconBySize("save", new Size(1))], react.createElement("span", {
            className: "head__icon",
            onClick: onSaveClick,
        }, ...children_2)), (children_4 = [getMaterialIconBySize("close", new Size(1))], react.createElement("span", {
            className: "head__icon",
            onClick: onCancelClick,
        }, ...children_4))];
        headerIcons = react.createElement("th", {
            className: "head head__icons",
        }, ...children_6);
    }
    else {
        const children_10 = [(children_8 = [getMaterialIconBySize("edit", new Size(1))], react.createElement("span", {
            className: "head__icon",
            onClick: onEditClick,
        }, ...children_8))];
        headerIcons = react.createElement("th", {
            className: "head head__icons",
        }, ...children_10);
    }
    const children_24 = [(children_22 = [(children_18 = [(children_16 = [(props_14 = [new HTMLAttr(65, "head"), ["style", {
        marginBottom: "0px",
    }]], (children_14 = [(props_12 = [["style", {
        display: "inline-flex",
    }]], react.createElement("div", keyValueList(props_12, 1), header, auxComponent))], react.createElement("th", keyValueList(props_14, 1), ...children_14))), headerIcons], react.createElement("tr", {}, ...children_16))], react.createElement("thead", {}, ...children_18)), react.createElement("tbody", {
        className: "body",
    }, ...rowsHtml)], react.createElement("table", {
        className: "table-side table-side--editable",
    }, ...children_22))];
    return react.createElement("div", {}, ...children_24);
}

export function renderEditableSideTable(header, rows, isEditing, onEditClick, onSaveClick, onCancelClick) {
    let children_2, children_4, children_8, children_20, children_16, children_14;
    const rowsHtml = map((row) => {
        const tableCells = map(Elements_renderCell, row[0]);
        return react.createElement("tr", {
            id: row[1],
        }, ...tableCells);
    }, rows);
    let headerIcons;
    if (isEditing) {
        const children_6 = [(children_2 = [getMaterialIconBySize("save", new Size(1))], react.createElement("span", {
            className: "head__icon",
            onClick: onSaveClick,
        }, ...children_2)), (children_4 = [getMaterialIconBySize("close", new Size(1))], react.createElement("span", {
            className: "head__icon",
            onClick: onCancelClick,
        }, ...children_4))];
        headerIcons = react.createElement("th", {
            className: "head head__icons",
        }, ...children_6);
    }
    else {
        const children_10 = [(children_8 = [getMaterialIconBySize("edit", new Size(1))], react.createElement("span", {
            className: "head__icon",
            onClick: onEditClick,
        }, ...children_8))];
        headerIcons = react.createElement("th", {
            className: "head head__icons",
        }, ...children_10);
    }
    const children_22 = [(children_20 = [(children_16 = [(children_14 = [react.createElement("th", {
        className: "head",
    }, header), headerIcons], react.createElement("tr", {}, ...children_14))], react.createElement("thead", {}, ...children_16)), react.createElement("tbody", {
        className: "body",
    }, ...rowsHtml)], react.createElement("table", {
        className: "table-side table-side--editable",
    }, ...children_20))];
    return react.createElement("div", {}, ...children_22);
}

function getNumberOfCells(rows) {
    if (!isEmpty(rows)) {
        return length(head(rows)[0]) | 0;
    }
    else {
        return 0;
    }
}

export class DotMenuProps extends Record {
    constructor(Items, RowId) {
        super();
        this.Items = Items;
        this.RowId = RowId;
    }
}

export function DotMenuProps$reflection() {
    return record_type("Components.Table.DotMenuProps", [], DotMenuProps, () => [["Items", list_type(tuple_type(string_type, lambda_type(string_type, unit_type)))], ["RowId", string_type]]);
}

const getDotMenuCellHtml = FunctionComponent_Of_Z5A158BBF((props) => {
    let children_2, children_7;
    const showMenuState = react.useState(false);
    const wrapperRef = react.useRef(void 0);
    react.useEffect(() => {
        const disp = (() => effect(wrapperRef, () => {
        showMenuState[1](false);
    }, void 0))();
        return () => disp.Dispose();
    });
    let dotMenuHtml;
    if (showMenuState[0]) {
        const children_4 = [(children_2 = map((item) => react.createElement("li", {
            className: "dotmenu__list-item",
            onClick: (_arg) => {
                showMenuState[1](false);
                item[1](props.RowId);
            },
        }, item[0]), props.Items), react.createElement("ul", {
            className: "dotmenu__list",
        }, ...children_2))];
        dotMenuHtml = react.createElement("div", {
            className: "cell__dotmenu",
        }, ...children_4);
    }
    else {
        dotMenuHtml = react.createElement(react.Fragment, {});
    }
    const children_9 = [(children_7 = [getWrappedMaterialIcon("more_vert")], react.createElement("span", {
        className: "cell__icon",
        onClick: (_arg_1) => {
            showMenuState[1]((value) => (!value));
        },
        ["data-regression"]: "triple-dot-button",
    }, ...children_7)), dotMenuHtml];
    return react.createElement("td", {
        className: "cell",
        ref: wrapperRef,
    }, ...children_9);
}, "DotMenuCell", uncurry(2, void 0), void 0, "getDotMenuCellHtml", "E:\\w\\1835\\s\\FenixWebApp\\fable\\src\\Components\\Table\\Table.fs", 495);

export function renderDotMenuAreaTable(headers, rows, dotMenuFn, expandableArea, expandAreaRowId, onRowClick) {
    let children_13;
    const numberOfCells = (getNumberOfCells(rows) + 1) | 0;
    const rows_1 = map((row) => {
        let expandableAreaHtml, props_8, children_8;
        const renderCell_1 = (rowIdOpt, nrOfCells, index, cellContents) => {
            const classes = classNames(ofArray([["cell", true], ["pointer", expandableArea != null], ["cell--align-right", (nrOfCells > 1) && ((nrOfCells - 1) === index)]]));
            const props = toList(delay(() => append_1(singleton_1(new HTMLAttr(65, classes)), delay(() => ((rowIdOpt != null) ? singleton_1(new DOMAttr(40, (_arg) => {
                onRowClick(value_3(rowIdOpt));
            })) : empty_1())))));
            return react.createElement("td", keyValueList(props, 1), cellContents);
        };
        const rowIdOpt_1 = row[1];
        const cells = row[0];
        const rowCells = mapIndexed(uncurry(2, partialApply(2, renderCell_1, [rowIdOpt_1, length(cells)])), cells);
        let dotMenuCell;
        if (rowIdOpt_1 == null) {
            dotMenuCell = renderCell_1(void 0, 1, 1, react.createElement(react.Fragment, {}));
        }
        else {
            const rowId = rowIdOpt_1;
            dotMenuCell = getDotMenuCellHtml(new DotMenuProps(dotMenuFn(rowId), rowId));
        }
        let expandableAreaRow;
        const matchValue = [expandAreaRowId, rowIdOpt_1, expandableArea];
        let pattern_matching_result, expandableAreaHtml_1, id_1, rowId_2;
        if (matchValue[0] != null) {
            if (matchValue[1] != null) {
                if (matchValue[2] != null) {
                    if ((expandableAreaHtml = matchValue[2], matchValue[0] === matchValue[1])) {
                        pattern_matching_result = 0;
                        expandableAreaHtml_1 = matchValue[2];
                        id_1 = matchValue[0];
                        rowId_2 = matchValue[1];
                    }
                    else {
                        pattern_matching_result = 1;
                    }
                }
                else {
                    pattern_matching_result = 1;
                }
            }
            else {
                pattern_matching_result = 1;
            }
        }
        else {
            pattern_matching_result = 1;
        }
        switch (pattern_matching_result) {
            case 0: {
                const children_5 = [react.createElement("td", {
                    className: "cell__expandable-area",
                    colSpan: numberOfCells,
                }, expandableAreaHtml_1)];
                expandableAreaRow = react.createElement("tr", {}, ...children_5);
                break;
            }
            case 1: {
                expandableAreaRow = react.createElement(react.Fragment, {});
                break;
            }
        }
        const children_10 = [(props_8 = toList(delay(() => ((rowIdOpt_1 != null) ? singleton_1(new HTMLAttr(99, value_3(rowIdOpt_1))) : empty_1()))), (children_8 = append(rowCells, singleton(dotMenuCell)), react.createElement("tr", keyValueList(props_8, 1), ...children_8))), expandableAreaRow];
        return react.createElement(react.Fragment, {}, ...children_10);
    }, rows);
    const children_15 = [(children_13 = [renderTHead(headers), react.createElement("tbody", {
        className: "body",
    }, ...rows_1)], react.createElement("table", {
        className: "editable-area-table",
    }, ...children_13))];
    return react.createElement("div", {}, ...children_15);
}

export function renderDotMenuTable(headers, rows, dotMenuFn) {
    return renderDotMenuAreaTable(headers, rows, dotMenuFn, void 0, void 0, (value) => {
    });
}

export function renderContentAreaTable(headers, rows, expandableArea, expandAreaRowId, onRowClick) {
    let children_12;
    const rows_1 = map((row) => {
        let props_2;
        const rowCellsHtml = map((cell) => react.createElement("td", {
            className: "cell pointer",
            onClick: (_arg) => {
                onRowClick(cell[1]);
            },
        }, cell[0]), row);
        const rowId = defaultArg(map_1((tuple) => tuple[1], tryHead(row)), "");
        let expandableAreaRowHtml;
        let pattern_matching_result;
        if (expandAreaRowId != null) {
            if (expandAreaRowId === rowId) {
                pattern_matching_result = 0;
            }
            else {
                pattern_matching_result = 1;
            }
        }
        else {
            pattern_matching_result = 1;
        }
        switch (pattern_matching_result) {
            case 0: {
                const children_4 = [(props_2 = [new HTMLAttr(65, "cell__expandable-area"), new HTMLAttr(67, length(row))], react.createElement("td", keyValueList(props_2, 1), expandableArea))];
                expandableAreaRowHtml = react.createElement("tr", {}, ...children_4);
                break;
            }
            case 1: {
                expandableAreaRowHtml = react.createElement(react.Fragment, {});
                break;
            }
        }
        const children_9 = [react.createElement("tr", {
            id: rowId,
        }, ...rowCellsHtml), expandableAreaRowHtml];
        return react.createElement(react.Fragment, {}, ...children_9);
    }, rows);
    const children_14 = [(children_12 = [renderTHead(headers), react.createElement("tbody", {
        className: "body",
    }, ...rows_1)], react.createElement("table", {
        className: "editable-area-table",
    }, ...children_12))];
    return react.createElement("div", {}, ...children_14);
}

export class CustomContentAreaTableProps extends Record {
    constructor(Headers, Rows, RenderExpandableAreaFn, RowIdState) {
        super();
        this.Headers = Headers;
        this.Rows = Rows;
        this.RenderExpandableAreaFn = RenderExpandableAreaFn;
        this.RowIdState = RowIdState;
    }
}

export function CustomContentAreaTableProps$reflection() {
    return record_type("Components.Table.CustomContentAreaTableProps", [], CustomContentAreaTableProps, () => [["Headers", list_type(class_type("Fable.React.ReactElement"))], ["Rows", list_type(tuple_type(list_type(class_type("Fable.React.ReactElement")), string_type))], ["RenderExpandableAreaFn", lambda_type(string_type, option_type(class_type("Fable.React.ReactElement")))], ["RowIdState", option_type(class_type("Fable.React.IStateHook`1", [option_type(string_type)]))]]);
}

export const renderCustomContentAreaTable = FunctionComponent_Of_Z5A158BBF((props) => {
    let children_15, children_11;
    let rowIdState_1;
    const matchValue = props.RowIdState;
    rowIdState_1 = ((matchValue == null) ? react.useState(void 0) : matchValue);
    const rows = map((row) => {
        let props_3;
        const rowId = row[1];
        let expandableAreaRow;
        const matchValue_1 = equals(rowIdState_1[0], rowId);
        if (matchValue_1) {
            const expandableAreaRowOpt = props.RenderExpandableAreaFn(rowId);
            if (expandableAreaRowOpt != null) {
                const expandableAreaHtml = expandableAreaRowOpt;
                const children_4 = [(props_3 = [new HTMLAttr(65, "cell__expandable-area"), new HTMLAttr(67, length(row[0]))], react.createElement("td", keyValueList(props_3, 1), expandableAreaHtml))];
                expandableAreaRow = react.createElement("tr", {}, ...children_4);
            }
            else {
                expandableAreaRow = react.createElement(react.Fragment, {});
            }
        }
        else {
            expandableAreaRow = react.createElement(react.Fragment, {});
        }
        const children_8 = [react.createElement("tr", {
            id: rowId,
            onClick: (_arg) => {
                rowIdState_1[1]((currentId) => (equals(currentId, rowId) ? (void 0) : rowId));
            },
        }, ...row[0]), expandableAreaRow];
        return react.createElement(react.Fragment, {}, ...children_8);
    }, props.Rows);
    const children_17 = [(children_15 = [(children_11 = [react.createElement("tr", {}, ...props.Headers)], react.createElement("thead", {}, ...children_11)), react.createElement("tbody", {
        className: "body",
    }, ...rows)], react.createElement("table", {
        className: "editable-area-table",
    }, ...children_15))];
    return react.createElement("div", {}, ...children_17);
}, "CustomContentAreaTable", uncurry(2, void 0), void 0, "renderCustomContentAreaTable", "E:\\w\\1835\\s\\FenixWebApp\\fable\\src\\Components\\Table\\Table.fs", 660);

